var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AsiContentContainer',{attrs:{"columns":_vm.columns}},_vm._l((_vm.num),function(i){return _c('AsiSkeletonCard',{key:`skeleton-card-${i}`,staticClass:"mb-6",attrs:{"loading":_vm.loading}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }